exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{display:block;cursor:pointer}#mobileVideo{position:absolute;width:0;height:0;left:-1000rem;top:-1000rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/wia-launcher/wia-launcher.css
// module id = XnWj
// module chunks = 0